import { Component, OnInit,Input,Output,EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.css']
})
export class ConfirmDialogComponent implements OnInit {
	@Input() title;
	@Input() message;
	@Output() confirmed: EventEmitter<any> = new EventEmitter();
	
	constructor(public activeModal: NgbActiveModal) { }

	ngOnInit() {
	}
	
	submitConfirmation(confirmation:boolean){
		
		this.confirmed.emit(confirmation);
		this.activeModal.dismiss();
		
	}

}
